































import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";

/**
 * A custom select component.
 */
@Component
export default class Select extends Vue {
	/// Injections

	/// Properties
	@Prop()
	label!: string;

	@Prop({ default: () => [] })
	items!: any[];

	@Prop()
	itemValue!: string;

	@Prop()
	itemText!: (item: any) => string;

	@Prop({ default: null })
	itemImage!: (item: any) => string;

	@Prop({ default: false })
	filled!: boolean;

	@Prop({ default: false })
	dense!: boolean;

	@Prop({ default: false })
	outlined!: boolean;
	
	@Prop({ default: false })
	clearable!: boolean;



	/// Attributes

	/** V-MODEL */
	@Model("change", { type: String })
	readonly externalModel!: string | null;

	internalModel: string | null = null;

	@Watch("internalModel")
	onInternalModelChanged(val: string) {
		this.$emit("change", val);
	}

	@Watch("externalModel")
	onExternalModelChanged(val: string) {
		this.internalModel = val;
	}
	
	created(){
		this.internalModel = this.externalModel;
	}
}
